import React, { useContext, useEffect, useRef, useState } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { InputTextarea } from "primereact/inputtextarea";
import { confirmDialog } from "primereact/confirmdialog";
import { Dropdown } from "primereact/dropdown";
import { Checkbox } from "primereact/checkbox";

// ------------------ COMPONENTES DE BASE--------------------------
import Card from "../../../Base/Components/Card/Card";
import Loader from "../../../Base/Components/Loader/Loader";
import AgGrid from "../../../Base/Components/Tables/AgGrid/AgGrid";
import { useForm } from "../../../Base/Hooks/useForm";
import { AuthContext } from "../../../Base/Context/AuthContext/AuthContext";
import AutoCompleteDropdown from "../../../Base/Components/Form/AutoCompleteDropdown";
import { toastShow } from "../../../Base/Services/ToastService";

// ------------------- CONSULTAS A LA API---------------------------
import { eliminarDetalles } from "../../../API/Finanzas/NotasProveedores/NotasProveedoresRequest";
import { getConstruccionesConcatenadas } from "../../../API/Global/Construcciones/ConstruccionesRequest";
import { agregarConstruccionSalidas, agregarCuentaSalidas, ObtenerDetalleSalidas, revisarSalidaFin } from "../../../API/Suministros/SalidasMateriales/SalidasMaterialesRequest";
import { ObtenerEncabezadoRequisa} from "../../../API/Suministros/IngresosMateriales/IngresosMaterialesRequest";
import { getCuentasHijosQuick } from "../../../API/Finanzas/RegistroContable/RegistroContableRequest";
import { getLiberarRequisas } from "../../../Base/API/IT/Accesos/AccesosRequests";
import IngresosBodegaCrud from "../../ERP/Suministros/Bodegas/IngresosBodega/IngresosCRUD/IngresosBodegaCrud";

const SalidasCRUD = ({
  showDialog,
  setShowDialog,
  selected,
  setSelected,
  getInfo,
  habilitar,
  setHabilitar,
}) => {
  const { userAuth } = useContext(AuthContext);
  const toast = useRef(null);

  const [detalles, setDetalles] = useState([]);
  const [selectedDet, setSelectedDet] = useState([]);
  const [loading, setLoading] = useState(false);
  const [ingresoToShow, setIngresoToShow] = useState([]);
  const [construcciones, setConstrucciones] = useState([]);
  const [cuentas, setCuentas] = useState([]);
  const [hiddenCostosSalidas, setHiddenCostosSalidad] = useState(userAuth.AccessWeb.split(",").map((e) => parseInt(e)).includes(29));
  const [showDialogI, setShowDialogI] = useState(false);
  const [dialogDividir, setDialogDividir] = useState(false);

  const initialValues = {
    IdSalidaDetalle: -1,
  };

  const { values, setValues, handleInputChange, handleChange, resetForm } = useForm(initialValues);

  const getValoresIniciales = async (salidas) => {
    setLoading(true);
    setSelectedDet([])
    let req = salidas ? salidas : values;
    const t = await ObtenerEncabezadoRequisa(req.Requisa);

    const agentesSolicita = await getLiberarRequisas();

    const construccionesTempo = await getConstruccionesConcatenadas()
    setConstrucciones(construccionesTempo)

    const cuentasTempo = await getCuentasHijosQuick()
    setCuentas(cuentasTempo)

    if (t.length > 0) {
        const det = await ObtenerDetalleSalidas(req.Requisa);
        setDetalles(det);
        setValues({
          ...t[0],
          FechaEnc: new Date(t[0].FechaEnc),
          UserNameSolicita: agentesSolicita.find(
            (ac) => ac.IdUser === t[0].IdSolicita
          ),
        });
      setHabilitar(false);
    }
    setLoading(false);
  };

  const verificarCampos = () => {
    let err = false;

    if (detalles.length > 0) {
      detalles.forEach((l) => {
        if (!l.IdSubConstruccion) {
          toastShow(
            toast,
            "error",
            "Error",
            "Debe seleccionar la construccion en los detalles"
          );
          err = true;
          return;
        }
      });
    }

    return !err;
  };

  const guardarNota = async () => {
    if (verificarCampos()) {
    }
  };

  const EliminarDetalle = async () => {
    if (selected.some((item) => item.IdNotaCreditoDet > 0)) {
      confirmDialog({
        message: "¿Está seguro que desea eliminar el detalle?",
        header: "Confirmación",
        icon: "pi pi-exclamation-triangle",
        accept: async () => {
          setLoading(true);
          const nuevosDetalles = detalles.filter(
            (detalle) =>
              !selected.some(
                (item) => item.IdNotaCreditoDet === detalle.IdNotaCreditoDet
              )
          );
          const Ids = selected
            .filter((item) => item.IdNotaCreditoDet > 0)
            .map((item) => item.IdNotaCreditoDet)
            .join(",");
          const resp = await eliminarDetalles(Ids);
          toastShow(
            toast,
            "success",
            "Eliminado",
            "Detalles eliminados correctamente"
          );
          setTimeout(() => {
            setLoading(false);
            setDetalles(nuevosDetalles);
            setSelected([]);
          }, 600);
        },
        reject: () => {},
      });
    } else {
      const idsAEliminar = selected.map((item) => item.IdNotaCreditoDet);
      const nuevosDetalles = detalles.filter(
        (detalle) => !idsAEliminar.includes(detalle.IdNotaCreditoDet)
      );
      setDetalles(nuevosDetalles);
      setSelected([]);
    }
  };

  const TemplateConstruccion = ({ data, oldValue, api }, column) => {
    return (
      <Dropdown
        value={data?.IdSubConstruccion}
        options={construcciones}
        optionValue="IdSubConstruccion"
        optionLabel="NombreCompuesto"
        filter
        filterBy="NombreCompuesto"
        style={{ width: "100%" }}
        onChange={(e) => {
          let ConstruccionSeleccionda = construcciones.filter(i => i?.IdSubConstruccion === e?.value);
          let changes = [];
          let mensaje = "";

          if (selectedDet.length > 0) {
            const revisados = selectedDet.filter(item => item?.IdEstadoFinanzas === 112);
            if (revisados.length > 0) {
              toastShow(toast, 'error', 'Error', 'Una o más salidas ya están revisadas. No se puede modificar la construcción.');
              return;
            }
            changes = selectedDet.map((item) => {
              return {
                IdSalidaDetalle: item.IdSalidaDetalle,
                IdConstruccion: ConstruccionSeleccionda[0]?.IdConstruccion,
                IdSubConstruccion: ConstruccionSeleccionda[0]?.IdSubConstruccion,
                NombreCompuesto: ConstruccionSeleccionda[0]?.NombreCompuesto,
                IdEstadoFinanzas: item?.IdEstadoFinanzas,
              };
            });
          } else {
            if (data?.IdEstadoFinanzas === 112) {
              toastShow(toast, 'error', 'Error', 'La salida ya está revisada, no puede eliminar la construcción.');
              return; 
            }

            changes.push({
              IdSalidaDetalle: data.IdSalidaDetalle,
              IdConstruccion: ConstruccionSeleccionda[0]?.IdConstruccion,
              IdSubConstruccion: ConstruccionSeleccionda[0]?.IdSubConstruccion,
              NombreCompuesto: ConstruccionSeleccionda[0]?.NombreCompuesto,
              IdEstadoFinanzas: data?.IdEstadoFinanzas,
            });
          }
          if (!ConstruccionSeleccionda[0]) {
            mensaje = `¿Está seguro de eliminar la construcción a ${changes.length} salidas?`;
          } else {
            mensaje = <>¿Agregar construcción <strong>{ConstruccionSeleccionda[0]?.NombreCompuesto}</strong> a {changes.length} salidas?</>;
          }

          confirmDialog({
            message: mensaje,
            header: "Confirmación",
            icon: "pi pi-exclamation-triangle",
            accept: async () => {
              let IdSalidaDetalles = changes.map((item) => item.IdSalidaDetalle);
              let IdSubConstruccion = ConstruccionSeleccionda[0]?.IdSubConstruccion;

              let data = {
                IdSalidas: IdSalidaDetalles.toString(','),
                IdConstruccion: ConstruccionSeleccionda[0]?.IdConstruccion,
                IdSubConstruccion: IdSubConstruccion,
                IdUserEdit: userAuth?.IdUser,
              };

              const resp = await agregarConstruccionSalidas(data);
              toastShow(toast, 'success', 'Agregada', 'Construcción agregada');
              getValoresIniciales();
              api.stopEditing();
            },
            reject: () => {},
          });

        }}
        showClear
      />
    );
  };

  const TemplateCuenta = ({ data, oldValue, api }, column) => {
    return (
      <Dropdown
        value={data?.IdAccount}
        options={cuentas}
        optionValue="IdAccount"
        optionLabel="NombreCuenta"
        filter
        filterBy="NombreCuenta"
        style={{ width: "100%" }}
        onChange={(e) => {
          let cuentaSeleccionada = cuentas.filter(i => i?.IdAccount === e?.value);
          let changes = [];
          let mensaje = "";

          if (selectedDet.length > 0) {
            const revisados = selectedDet.filter(item => item?.IdEstadoFinanzas === 112);
            if (revisados.length > 0) {
              toastShow(toast, 'error', 'Error', 'Una o más salidas ya están revisadas, no puede eliminar la construcción.');
              return;
            }

            changes = selectedDet.map((item) => {
              return {
                IdSalidaDetalle: item.IdSalidaDetalle,
                IdAccount: cuentaSeleccionada[0]?.IdAccount,
                NombreCuenta: cuentaSeleccionada[0]?.NombreCuenta,
                IdEstadoFinanzas: item?.IdEstadoFinanzas,
              };
            });
          } else {
            if (data?.IdEstadoFinanzas === 112) {
              toastShow(toast, 'error', 'Error', 'La salida ya está revisada, no puede eliminar la construcción.');
              return; 
            }

            changes.push({
              IdSalidaDetalle: data.IdSalidaDetalle,
              IdAccount: cuentaSeleccionada[0]?.IdAccount,
              NombreCuenta: cuentaSeleccionada[0]?.NombreCuenta,
              IdEstadoFinanzas: data?.IdEstadoFinanzas,
            });
          }
          if (!cuentaSeleccionada[0]) {
            mensaje = `¿Está seguro de eliminar la cuenta a ${changes.length} salidas?`;
          } else {
            mensaje = <>¿Agregar cuenta <strong>{cuentaSeleccionada[0]?.NombreCuenta}</strong> a {changes.length} salidas?</>;
          }

          confirmDialog({
            message: mensaje,
            header: "Confirmación",
            icon: "pi pi-exclamation-triangle",
            accept: async () => {
              let IdSalidaDetalles = changes.map((item) => item.IdSalidaDetalle);

              let data = {
                IdSalidas: IdSalidaDetalles.toString(','),
                IdAccount: cuentaSeleccionada[0]?.IdAccount,
                IdUserEdit: userAuth?.IdUser,
              };

              const resp = await agregarCuentaSalidas(data);
              toastShow(toast, 'success', 'Agregada', 'Cuenta agregada correctamente');
              getValoresIniciales();
              api.stopEditing();
            },
            reject: () => {},
          });

        }}
        showClear
      />
    );
  };

  const RevisarFinanzas = async (rowData) => {
    const dataToProcess = selectedDet?.length > 1 ? selectedDet : [rowData];
    const notRevisados = dataToProcess.filter(item => !item?.Revisado);
    if (notRevisados.length === 0) {
      confirmDialog({
      message: `¿Está seguro quitar el revisado a ${dataToProcess?.length} ${dataToProcess?.length > 1 ? 'salidas' : 'salida'}?`,
      header: "Confirmación",
      icon: "pi pi-exclamation-triangle",
      accept: async () => {
        const IdSalidas = dataToProcess.map(i => i?.IdSalidaDetalle);
        const dataEnviar = {
          IdSalidas: IdSalidas.join(','),
          IdUserRevisoFin: null,
          Revisado: false,
        };
        const resp = await revisarSalidaFin(dataEnviar)
        toastShow(toast, 'success', 'Revisada', 'Salida Revisada correctamente');
        getValoresIniciales();
      },
      reject: () => {},
    });
      return;
    }

    const invalidItems = notRevisados.filter(item => !item?.IdAccount || !item?.IdConstruccion);
    if (invalidItems.length > 0) {
      toastShow(toast, 'error', 'Error', 'Solo se pueden revisar salidas con Cuenta Contable y Construcción asignadas.');
      return;
    }


    confirmDialog({
      message: `¿Está seguro de revisar ${notRevisados?.length} ${notRevisados?.length > 1 ? 'salidas' : 'salida'}?`,
      header: "Confirmación",
      icon: "pi pi-exclamation-triangle",
      accept: async () => {
        const IdSalidas = notRevisados.map(i => i?.IdSalidaDetalle);
        const dataEnviar = {
          IdSalidas: IdSalidas.join(','),
          IdUserRevisoFin: userAuth?.IdUser,
          Revisado: true,
        };

        const resp = await revisarSalidaFin(dataEnviar)
        toastShow(toast, 'success', 'Revisada', 'Salida Revisada correctamente');
        getValoresIniciales();
      },
      reject: () => {},
    });

    // console.log(dataEnviar);
  };

  const DividirSalida = () => {
    if (selectedDet.length > 0) {
      if (selectedDet[0]?.IdEstadoFinanzas !== 112) {
        let message = <div>¿Está seguro que desea dividir la salida? </div>
        confirmDialog({
          message: message,
          header: 'Confirmación',
          icon: 'pi pi-exclamation-triangle',
          accept: () => {
            setDialogDividir(true)
          },
          reject: () => {}
        })
      } else {
        toastShow(toast, 'error', 'Acción no disponible', 'La salida se encuentra revisada');
      }
    } else {
      toastShow(toast, 'warn', 'Seleccione un item', 'Debe seleccionar un item');
    }
  }

  const hideDividir = () => {
    setDialogDividir(false)
    setSelected([])
  }

  const columns = [
    {
      header: "ID",
      headerEn: "ID",
      field: "IdSalidaDetalle",
      frozen: true,
      className: "XXsmall",
      hidden: userAuth.IdRol === 1,
    },
    {
      header: "Fecha Salida",
      headerEn: "Departure Date",
      field: "FechaSalida",
      Format: "DateTime",
      frozen: true,
      className: "medium",
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "StatusName",
      frozen: true,
      className: "small",
      Format: "Estado",
      body: (rowData) => ({
        ID: rowData?.IdEstado,
        Estado: rowData?.StatusName,
      }),
    },
    {
      header: "Código Producto",
      headerEn: "Purchase Order",
      className: "Xsmall",
      field: "CodigoProducto",
    },
    {
      header: "Producto",
      headerEn: "Product",
      field: "NombreProducto",
      className: "large",
    },
    {
      header: "Descripción Producto",
      headerEn: "Product Description",
      field: "DescripcionProducto",
      className: "large",
    },
    {
      header: "Comentario de Salida",
      headerEn: "Comment",
      field: "Comentario",
      className: "large",
    },
    {
      field: "NombreCompuesto",
      header: "Construcción",
      headerEn: "Construccion",
      className: "XXXlarge",
      editable: habilitar,
      cellEditor: TemplateConstruccion,
    },
    {
      field: "NombreCuenta",
      header: "Cuenta",
      headerEn: "Account",
      className: "XXXlarge",
      editable: habilitar,
      cellEditor: TemplateCuenta,
    },
    {
      header: "Tipo Producto",
      headerEn: "Product Type",
      field: "NombreCategoria",
      className: "Xsmall",
    },
    {
      header: "Categoría",
      headerEn: "Category",
      field: "NombreSubcategoria",
      className: "Xsmall",
    },
    {
      // PurchaseRequest
      field: "NumeroIngreso",
      headerEn: "Entry Number",
      header: "No.Ingreso",
      className: "Xsmall",
      body: (rowData) => rowData.NumeroIngreso,
      align: "center",
      onCellDoubleClicked: ({ data }) => {
        setIngresoToShow(data?.NumeroIngreso);
        setShowDialogI(true);
        // Ingreso(data.Requisa);
      },
    },
    {
      header: "Unidad",
      headerEn: "Product",
      field: "UnitName",
      className: "Xsmall",
    },
    {
      // Comment
      field: "Area",
      header: "Area",
      headerEn: "Area",
      className: "medium",
    },
    {
      // Comment
      field: "UserNameDespacho",
      header: "Usuario Despacho",
      headerEn: "Usuario Despacho",
      className: "small",
    },
    {
      field: "PrecioL",
      header: "Precio L",
      headerEn: "Price L",
      Sumary: "sum",
      className: "Xsmall",
      hidden: hiddenCostosSalidas,
      Format: "Currency",
    },
    {
      field: "PrecioD",
      header: "Precio D",
      headerEn: "Price D",
      Sumary: "sum",
      className: "Xsmall",
      Format: "Currency",
      hidden: hiddenCostosSalidas,
    },
    {
      header: "Estado Finanzas",
      field: "StatusNameFinanzas",
      frozen: true,
      className: "small",
      alignFrozen: "right",
      Format: "Estado",
      body: (rowData) => ({ ID: rowData.IdEstadoFinanzas, Estado: rowData.StatusNameFinanzas }),
    },
    {
      field: "Revisado",
      header: "Revisado",
      className: "Xsmall",
      Format: "Template",
      frozen: "true",
      alignFrozen: "right",
      filter: false,
      body: (rowData) => (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
          <Checkbox checked={rowData.Revisado === 1 ? true : false} onClick={() => RevisarFinanzas(rowData)} />
        </div>
      ),
    },
    {
      field: "MontoL",
      header: "Monto L",
      headerEn: "Monto L",
      className: "Xsmall",
      hidden: hiddenCostosSalidas,
      Sumary: "sum",
      frozen: "frozen",
      Format: "Currency",
      alignFrozen: "right",
    },
    {
      field: "MontoD",
      header: "Monto D",
      headerEn: "Monto D",
      className: "small",
      hidden: hiddenCostosSalidas,
      Sumary: "sum",
      Format: "Currency",
      frozen: "frozen",
      alignFrozen: "right",
    },
    {
      header: "Inventario",
      headerEn: "Amount",
      field: "Inventario",
      className: "Xsmall",
      Sumary: "sum",
      Format: "Currency",
    },
    {
      header: "Solicitado",
      headerEn: "Requested",
      field: "Qty",
      className: "Xsmall",
      Sumary: "sum",
      Format: "Currency",
      frozen: "frozen",
      alignFrozen: "right",
    },
    {
      header: "Balance",
      field: "BalanceSalida",
      className: "Xsmall",
      Sumary: "sum",
      Format: "Currency",
      frozen: "frozen",
      alignFrozen: "right",
    },
    {
      header: "Despachado",
      field: "QtySalida",
      className: "Xsmall",
      //   editable: habilitar,
      //   onChange: (data) => changeQtySalida(data),
      Sumary: "sum",
      Format: "Currency",
      frozen: "frozen",
      alignFrozen: "right",
    },
  ];

  const table = {
    Columns: columns,
    Data: detalles,
    selected: selectedDet,
    setSelected: setSelectedDet,
    showModal: (e) => {},
  };

  useEffect(() => {
    getValoresIniciales(selected);
  }, [selected]);

  const cerrarDialog = () => {
    if (habilitar) {
      confirmDialog({
        message: "¿Está seguro que desea salir sin guardar?",
        header: "Confirmación",
        icon: "pi pi-exclamation-triangle",
        accept: () => {
          setShowDialogI(false);
          setSelected([]);
          resetForm();
          setDetalles([]);
          setHabilitar(true);
        },
        reject: () => {},
      });
    } else {
      setShowDialogI(false);
      setSelected([]);
      setHabilitar(true);
    }
  };

  const cerrarConfirmacion = () => {
    // Mostrar confirmación si hay ediciones sin guardar
    if (habilitar && ingresoToShow !== null) {
      confirmDialog({
        message: "¿Estás seguro de cerrar sin guardar los cambios?",
        header: "Cerrar sin guardar",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Sí",
        accept: () => {
          setShowDialog(null);
          setIngresoToShow(null); // Cerrar el diálogo
        },
        rejectLabel: "No",
        reject: () => {}, // No hacer nada si el usuario cancela
        style: { backgroundColor: "white" },
      });
    } else {
      setShowDialog(null);
      setIngresoToShow(null);
      setHabilitar(true);
    }
  };

  return (
    <div>
      <Dialog
        visible={showDialog}
        onHide={() => cerrarDialog()}
        header={"Salida"}
        style={{ width: "90vw", height: "90vh" }}
        maximizable
        maximized
      >
        <Loader loading={loading} />
        <Toast ref={toast} />

        {/* ENCABEZADO */}
        <div className="d-flex flex-column">
          <Card
            contenido={
              <div className="d-flex">
                <div className="col-12">
                  {/* ------------------------- CAMPOS ----------------------- */}
                  <div className="d-flex flex-wrap align-items-start gap-3 mt-2">
                    {/* No. Requisa */}
                    <span className="p-inputgroup " style={{ maxWidth: 235 }}>
                      <span className=" field p-float-label">
                        <InputText
                          id="Requisa"
                          name="Requisa"
                          value={values?.Requisa}
                          onChange={handleInputChange}
                          style={{ fontWeight: "bold" }}
                          onKeyDown={(e) =>
                            e.keyCode === 13 ? getValoresIniciales(e) : null
                          }
                        />
                        <label htmlFor="idEncabezado">
                          No. Requisa Material
                        </label>
                      </span>

                      <Button
                        icon="pi pi-search"
                        type="button"
                        className="p-button-info "
                        onClick={() => getValoresIniciales()}
                        tooltip="Buscar Salida"
                        tooltipOptions={{
                          className: "purple-tooltip",
                          position: "top",
                        }}
                      />
                    </span>

                    {/* Fecha */}
                    <span className="p-float-label">
                      <Calendar
                        id="Fecha"
                        name="FechaEnc"
                        disabled
                        value={values?.FechaEnc}
                        dateFormat="dd/mm/yy"
                        mask="99/99/9999"
                        showIcon
                      />
                      <label htmlFor="Date">Fecha Creación</label>
                    </span>

                    {/* Estado */}
                    <span className=" p-float-label">
                      <InputText
                        id="estado"
                        disabled
                        name="estado"
                        value={values?.StatusName}
                        style={{ width: "100%", padding: "6px 3px" }}
                      />
                      <label htmlFor="estado">Estado</label>
                    </span>

                    {/* Usuario */}
                    <span className=" p-float-label">
                      <InputText
                        disabled
                        id="UserCreate"
                        name="UserCreate"
                        value={values.UserNameCreate || userAuth?.UserName}
                        autoFocus
                        style={{ width: "100%", padding: "6px 3px" }}
                      />
                      <label htmlFor="usuario">Usuario Creación</label>
                    </span>

                    <AutoCompleteDropdown
                      enable={false}
                      value={values.UserNameSolicita}
                      // items={agentes}
                      field={"UserName"}
                      name={"UserNameSolicita"}
                      handleInputChange={handleInputChange}
                      label={"Usuario Autorizó"}
                      disabled
                    />

                    <AutoCompleteDropdown
                      enable={false}
                      value={values.Area}
                      // items={areas}
                      field={"Area"}
                      name={"Area"}
                      handleInputChange={handleInputChange}
                      tabIndex={4}
                      label={"Area"}
                      disabled
                    />

                    <AutoCompleteDropdown
                      enable={false}
                      name={"Priority"}
                      value={values.Priority}
                      // items={prioridades}
                      field={"Priority"}
                      label={"Prioridad"}
                      handleInputChange={handleInputChange}
                      disabled
                    />

                    {/* Comentarios */}
                    <span className="p-float-label">
                      <InputTextarea
                        disabled={true}
                        id="Comentarios"
                        name="Comentarios"
                        value={values?.Comentarios}
                        onChange={handleInputChange}
                        cols={86.3}
                        rows={2}
                        style={{
                          width: "63vh",
                          height: "3rem",
                        }}
                      />
                      <label id="label_comentario" htmlFor="Comentarios">
                        Comentarios
                      </label>
                    </span>
                  </div>

                  {/* --------------------------BOTONES-----------------------  */}
                  <div className="d-flex flex-wrap gap-1 mb-2 mt-3">
                    <Button
                      icon="pi pi-pencil"
                      type="button"
                      onClick={() => setHabilitar(true)}
                      tooltip="Editar"
                      tooltipOptions={{ position: "top" }}
                    />

                    <Button
                      icon="pi pi-save"
                      type="button"
                      onClick={guardarNota}
                      tooltip="Guardar"
                      tooltipOptions={{ position: "top" }}
                      disabled={!habilitar || detalles?.length === 0}
                    />

                    {/* <Button
                      icon="pi pi-times"
                      type="button"
                      className="p-button-danger"
                      onClick={() => EliminarDetalle()}
                      tooltip="Eliminar"
                      disabled={!habilitar || selected?.length === 0}
                      tooltipOptions={{ position: "top" }}
                    /> */}

                    <Button
                      icon="pi pi-sync"
                      type="button"
                      onClick={() => getValoresIniciales()}
                      tooltip="Cargar"
                      tooltipOptions={{ position: "top" }}
                    />

                    <Button
                      label="Dividir Detalle "
                      icon="ri-split-cells-horizontal"
                      disabled={!habilitar}
                      onClick={() => DividirSalida()}
                      style={{ marginLeft: 1, height: "47px" }}
                    />
                  </div>
                </div>
              </div>
            }
          />
        </div>

        {/* DETALLES */}
        <Card
          contenido={
            <div style={{ height: "56vh" }}>
              <AgGrid table={table} />
            </div>
          }
        />
      </Dialog>


      <Dialog
        visible={showDialogI}
        onHide={() => {
          cerrarConfirmacion();
        }}
        maximized={true}
        maximizable={true}
        closeOnEscape={false}
      >
        <IngresosBodegaCrud
          idIngreso={ingresoToShow}
          setIngresoToShow={setIngresoToShow}
          showDialog={showDialogI}
          // actualizarIngresosScreen={actualizarIngresosScreen}
          // actualizarIngresosScreenListado={actualizarIngresosScreenListado}
          // setOrderToShow={setOrderToShow}
          // setOrdenDialog={setOrdenDialog}
          habilitar={habilitar}
          setHabilitar={setHabilitar}
          editable={false}
        />
      </Dialog>
    </div>
  );
};

export default SalidasCRUD;
